// extracted by css-extract-rspack-plugin
export default {"cls1":"session_trail-cls1_d7y","cls2":"session_trail-cls2_SZ1 session_trail-cls1_d7y"};